// Opciones para que Sentry 11 junte lo mismo que juntaba Sentry 10 (sendDefaultPii sin
// setear). En la 11, dejar `dataCollection` sin poner manda cookies, cuerpos de los
// pedidos, la IP y los datos del usuario. El bloque es el de la guia oficial
// (MIGRATION.md, "If you want to keep the v10 default behavior").
// Lo usan instrumentation-client.js, sentry.server.config.js y sentry.edge.config.js.

const DENY_PII = ["forwarded", "-ip", "remote-", "via", "-user"];

export const SENTRY_OPCIONES_V10 = {
  dataCollection: {
    userInfo: false,
    cookies: false,
    httpHeaders: {
      request: { deny: DENY_PII },
      response: { deny: DENY_PII },
    },
    httpBodies: [],
    urlQueryParams: { deny: DENY_PII },
    genAI: { inputs: false, outputs: false },
    databaseQueryData: false,
    queues: false,
    graphQL: { document: false, variables: false },
    // En la 10 eran 7 lineas de contexto; la 11 baja a 5.
    frameContextLines: 7,
  },
  // En la 11 pasa a true: los captureMessage sumarian stack trace y armarian
  // issues nuevos en vez de agruparse con los de siempre.
  attachStacktrace: false,
};
